<template>
  <div class="full-height">
    <div
      :class="{
        simpleButtons: rowButtons,
        crudButtons: !rowButtons,
        cleanLayout: cleanLayout
      }"
      class="row container q-px-sm"
    >
      <div class="fit">
        <q-card class="q-pa-sm card-crud">
          <q-card-section class="q-pb-lg card-table">
            <vehicle-dwell-time-table
              v-if="nmInterface"
              ref="jtDataTable"
              class="table-crud"
              :buttons="datatable.buttons"
              :buttons-filter="filterButtons"
              :fields="datatable.columns"
              :extra-params="extraParam"
              :default-http-options="defaultHttpOptions"
              :nm-interface="nmInterface"
              singleselect
              :row-buttons="rowButtons"
              @selection="selection"
              @action-button="actionButton"
              @show-message="showMessage"
            />
          </q-card-section>
        </q-card>
      </div>
    </div>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud } from 'jtech-webcomps'
import VehicleDwellTimeTable from './VehicleDwellTimeTable'
const { pageTable } = JtCrud

@Component({
  components: { VehicleDwellTimeTable },
  mixins: [pageTable],
  props: {
    name: String,
    params: { type: Object, required: true },
    datatable: { type: Object, required: true },
    forms: { type: Array, required: true },
    parent: Object,
    rowButtons: {
      required: false,
      type: Boolean,
      default: false
    },
    cleanLayout: {
      required: false,
      type: Boolean,
      default: false
    }
  }
})
class VehicleDwellTimePageTable extends Vue {}
export default VehicleDwellTimePageTable
</script>
